export default __webpack_public_path__ + "static/media/Series-9100-MPNH-Inline-Remote-FAT.5d92581e.png";